import RaceItem from './RaceItem';

export default RaceItem;
